import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

const LoadingSpinner = () => (
  <div className="loader-container">
    <div className="loading-overlay">
      <ProgressSpinner />
    </div>
  </div>
);

export default LoadingSpinner;